import React from 'react';
import Spacer from './Spacer';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';

const spacerConfig = {
  label: 'Espace',
  // Longueur CSS (px affichés dans le champ, stockage rem) — comme le reste
  // des espacements du webviewer.
  defaultProps: { height: '2rem' },
  fields: {
    height: puckPxSpacingField('Hauteur'),
  },
  render: (props) => <Spacer {...props} />,
};

export default spacerConfig;
